// extracted by mini-css-extract-plugin
export var introSection = "IntroSection-module--introSection--Ht0H6";
export var introSectionContainer = "IntroSection-module--introSectionContainer--a-4OI";
export var introSectionInner = "IntroSection-module--introSectionInner--qRFef";
export var contentText = "IntroSection-module--contentText--HWvnf";
export var titleUnderline = "IntroSection-module--titleUnderline--6reJH";